/**
 * Query to update user
 */
 export const updateUserAttributes = `
 mutation updateUser($input:InputUpdateUser!) {
  updateUser(input:$input)
 }
`;